import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import { Container } from "./styles"

type DatePickerProps = {
  type: 'date' | 'time' | 'dateAndTime';
  modelType?: 'simple' | 'advanced'
  handleChangeCallback?: (value: string) => void;
  initialValue?: Date,
}

export const DatePicker = ({type = 'date', handleChangeCallback, modelType = 'simple', initialValue = new Date()}: DatePickerProps) => {
  const [selectedDate, setSelectedDate] = useState(initialValue);

  const handleDateChange = (value: any) => {
    if (handleChangeCallback) handleChangeCallback(value);
    setSelectedDate(new Date(value));
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Container modelType={modelType}>
      {type === 'date' && <KeyboardDatePicker value={selectedDate} onChange={handleDateChange} className={modelType === "advanced" && "container"}/>}
      {type === 'time' && <TimePicker value={selectedDate} onChange={handleDateChange} className={modelType === "advanced" && "container"} />}
      {type === 'dateAndTime' && <KeyboardDateTimePicker value={selectedDate} onChange={handleDateChange} className={modelType === "advanced" && "container"} />}
      </Container>
    </MuiPickersUtilsProvider>
  );
}